"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERROR_CLASSES = exports.authCurrentUserReducer = exports.authCurrentSessionReducer = undefined;

var _apiAuthCurrentSession = require("../actions/apiAuthCurrentSession");

var _apiAuthCurrentUser = require("../actions/apiAuthCurrentUser");

var _apiAuthLogin_post = require("../actions/apiAuthLogin_post");

var _apiAuthLogout = require("../actions/apiAuthLogout");

var authCurrentSessionReducer = exports.authCurrentSessionReducer = function authCurrentSessionReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        loading: false,
        data: null,
        error: null
    };
    var action = arguments[1];


    switch (action.type) {
        case _apiAuthCurrentSession.API_AUTH_CURRENT_SESSION_REQUEST:
        case _apiAuthCurrentSession.API_AUTH_CURRENT_SESSION_FAILURE:
        case _apiAuthCurrentSession.API_AUTH_CURRENT_SESSION_SUCCESS:
            return Object.assign({}, state, action.payload);
            break;

        default:
            return state;
    }
};

var authCurrentUserReducer = exports.authCurrentUserReducer = function authCurrentUserReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        loading: false,
        data: null,
        error: null
    };
    var action = arguments[1];


    switch (action.type) {

        case _apiAuthCurrentUser.API_AUTH_CURRENT_USER_REQUEST:
        case _apiAuthCurrentUser.API_AUTH_CURRENT_USER_FAILURE:
        case _apiAuthCurrentUser.API_AUTH_CURRENT_USER_SUCCESS:
        case _apiAuthLogin_post.API_AUTH_LOGIN_POST_SUCCESS:
        case _apiAuthLogin_post.API_AUTH_LOGIN_POST_REQUEST:
        case _apiAuthLogin_post.API_AUTH_LOGIN_POST_FAILURE:
        case _apiAuthLogout.API_AUTH_LOGOUT_SUCCESS:
            return Object.assign({}, state, action.payload);
            break;

        default:
            return state;
    }
};

var ERROR_CLASSES = exports.ERROR_CLASSES = ["AuthManagerUserPasswordWrongException", "AuthManagerCredentialServerException", "LoginNotEnabledException"];